import {
  athleteObjectives,
  athleteObjectivesControl,
  optionLogsBase,
  recuperationBase,
  recuperationBaseControl,
  reposoBase,
  reposoBaseControl,
  saturationBase,
  saturationBaseControl,
  testPhysicalBase,
} from "../constants";

const classContainer = "d-flex gap-2 flex-column  mx-auto my-2 px-4";

export const HabitComponent = ({ formData, control }) => {
  const habit_goals = formData?.habit_goals || null;

  return (
    <div className={classContainer}>
      {athleteObjectives.map((item) => {
        if (habit_goals && habit_goals.hasOwnProperty(item.label)) {
          return (
            <div className="col-12  d-flex ">
              <div
                className="col-9 input-tooltip-valoration fw-bold"
                style={{ textAlign: "left" }}
              >
                {item.name}
              </div>
              <div className="col-3 input-tooltip-valoration fw-bold">
                {habit_goals?.[item.label] || "---"}
              </div>
            </div>
          );
        }
      })}
    </div>
  );
};

export const HabitComponentControl = ({ formData, control, dash = false }) => {
  const habit_goals = formData?.achieved_goals?.habit_building || null;

  return (
    <div className={classContainer}>
      {dash ? (
        <>
          {athleteObjectivesControl.map((item) => {
            if (habit_goals && habit_goals.hasOwnProperty(item.label)) {
              return (
                <div className="col-12  d-flex ">
                  <div
                    className="col-9 input-tooltip-valoration fw-bold"
                    style={{ textAlign: "left" }}
                  >
                    {item.name}
                  </div>
                  <div className="col-3 input-tooltip-valoration fw-bold">
                    {habit_goals?.[item.label]?.goal_value || "---"}
                  </div>
                </div>
              );
            }
          })}
        </>
      ) : (
        <>
          <div className="col-12  d-flex ">
            <div
              className="col-4 input-tooltip-valoration fw-bold"
              style={{ textAlign: "left" }}
            ></div>
            <div className="col-2 input-tooltip-valoration fw-bold mx-1">
              {formData?.initial_date || "---"}
              <br></br>
              Valor inicial
            </div>
            <div className="col-2 input-tooltip-valoration fw-bold mx-1">
              <br></br>
              Valor objetivo
            </div>
            <div className="col-2 input-tooltip-valoration fw-bold mx-1">
              {formData?.current_date || "---"}
              <br></br>
              Valor alcanzado
            </div>
            <div className="col-2 input-tooltip-valoration fw-bold mx-1">
              <br></br>
              Resultado
            </div>
          </div>
          {athleteObjectivesControl.map((item) => {
            if (habit_goals && habit_goals.hasOwnProperty(item.label)) {
              return (
                <div className="col-12  d-flex ">
                  <div
                    className="col-4 input-tooltip-valoration fw-bold mx-1"
                    style={{ textAlign: "left" }}
                  >
                    {item.name}
                  </div>
                  <div
                    className="col-2 input-tooltip-valoration fw-bold mx-1"
                    style={{ color: " #b6c1ce" }}
                  >
                    {habit_goals?.[item.label]?.initial_value}
                  </div>
                  <div
                    className="col-2 input-tooltip-valoration fw-bold mx-1"
                    style={{ color: " #b6c1ce" }}
                  >
                    {habit_goals?.[item.label]?.goal_value || "---"}
                  </div>
                  <div className="col-2 input-tooltip-valoration fw-bold mx-1">
                    {habit_goals?.[item.label]?.current_value}
                  </div>
                  <div className="col-2 input-tooltip-valoration fw-bold mx-1">
                    {habit_goals?.[item.label]?.achieved ? (
                      <i
                        className="bi bi-check-circle-fill"
                        style={{ color: "#00FF00" }}
                      ></i>
                    ) : (
                      (
                        <i
                          className="bi bi-x-circle-fill"
                          style={{ color: "#ff0000" }}
                        ></i>
                      ) || "---"
                    )}{" "}
                  </div>
                </div>
              );
            }
          })}
        </>
      )}
    </div>
  );
};
export const CardioVascularComponentControl = ({
  formData,
  dash = false,
  setFormData,
}) => {
  console.log(formData, "carlos");
  const cardiovascular_rest_goals =
    formData?.achieved_goals?.cardiovascular?.rest_test || null;
  const cardiovascular_recovery_goals =
    formData?.achieved_goals?.cardiovascular?.recovery_test || null;
  const saturation_pressure_goals =
    formData?.achieved_goals?.cardiovascular?.oxygen_saturation || null;
  const blood_pressure =
    formData?.achieved_goals?.cardiovascular?.blood_pressure || null;
  return (
    <div className={classContainer}>
      {dash ? (
        <>
          {/* rest */}
          {cardiovascular_rest_goals && (
            <>
              <div
                className="d-flex align-items-center mx-auto my-2"
                style={{ width: "auto" }}
              >
                <span className="label-step-objectives ms-2">
                  Prueba en reposo
                </span>
              </div>
              <div className="col-12  d-flex ">
                <div
                  className="col-6 input-tooltip-valoration fw-bold"
                  style={{ textAlign: "left" }}
                ></div>
                <div className="col-3 input-tooltip-valoration fw-bold">
                  Valor actual
                </div>
                <div className="col-3 input-tooltip-valoration fw-bold">
                  Valor objetivo
                </div>
              </div>
              {reposoBaseControl.map((item) => {
                const nuevoKey = item.label.replace("goal", "actual");
                if (
                  cardiovascular_rest_goals &&
                  cardiovascular_rest_goals.hasOwnProperty(item.label)
                ) {
                  return (
                    <div className="col-12  d-flex ">
                      <div
                        className="col-6 input-tooltip-valoration fw-bold"
                        style={{ textAlign: "left" }}
                      >
                        {item.name}
                      </div>
                      <div
                        className="col-3 input-tooltip-valoration fw-bold"
                        style={{ color: " #b6c1ce" }}
                      >
                        {cardiovascular_rest_goals?.[item.label]?.current ||
                          "---"}
                      </div>
                      <div className="col-3 input-tooltip-valoration fw-bold">
                        {cardiovascular_rest_goals?.[item.label]?.goal || "---"}
                      </div>
                    </div>
                  );
                }
              })}
            </>
          )}
          {/* recuperation */}
          {cardiovascular_recovery_goals && (
            <>
              <div
                className="d-flex align-items-center mx-auto my-2"
                style={{ width: "auto" }}
              >
                <span className="label-step-objectives ms-2">
                  Prueba de recuperación
                </span>
              </div>

              <div className="col-12  d-flex ">
                <div
                  className="col-6 input-tooltip-valoration fw-bold"
                  style={{ textAlign: "left" }}
                ></div>
                <div className="col-3 input-tooltip-valoration fw-bold">
                  Valor actual
                </div>
                <div className="col-3 input-tooltip-valoration fw-bold">
                  Valor objetivo
                </div>
              </div>
              {recuperationBaseControl.map((item) => {
                const nuevoKey = item.label.replace("goal", "actual");
                if (
                  cardiovascular_recovery_goals &&
                  cardiovascular_recovery_goals.hasOwnProperty(item.label)
                ) {
                  return (
                    <div className="col-12  d-flex ">
                      <div
                        className="col-6 input-tooltip-valoration fw-bold"
                        style={{ textAlign: "left" }}
                      >
                        {item.name}
                      </div>
                      <div
                        className="col-3 input-tooltip-valoration fw-bold"
                        style={{ color: " #b6c1ce" }}
                      >
                        {cardiovascular_recovery_goals?.[item.label]?.current ||
                          "---"}
                      </div>
                      <div className="col-3 input-tooltip-valoration fw-bold">
                        {cardiovascular_recovery_goals?.[item.label]?.goal ||
                          "---"}
                      </div>
                    </div>
                  );
                }
              })}
            </>
          )}

          {/* saturation*/}
          {saturation_pressure_goals && (
            <>
              <div
                className="d-flex align-items-center mx-auto my-2"
                style={{ width: "auto" }}
              >
                <span className="label-step-objectives ms-2">
                  Saturación oxigeno / Tensión arterial
                </span>
              </div>

              <div className="col-12  d-flex ">
                <div
                  className="col-6 input-tooltip-valoration fw-bold"
                  style={{ textAlign: "left" }}
                ></div>
                <div className="col-3 input-tooltip-valoration fw-bold">
                  Valor actual
                </div>
                <div className="col-3 input-tooltip-valoration fw-bold">
                  Valor objetivo
                </div>
              </div>
              {saturationBaseControl.map((item) => {
                const nuevoKey = item.label.replace("goal", "actual");
                if (
                  saturation_pressure_goals &&
                  saturation_pressure_goals.hasOwnProperty(item.label)
                ) {
                  return (
                    <div className="col-12  d-flex ">
                      <div
                        className="col-6 input-tooltip-valoration fw-bold"
                        style={{ textAlign: "left" }}
                      >
                        {item.name}
                      </div>
                      <div
                        className="col-3 input-tooltip-valoration fw-bold"
                        style={{ color: " #b6c1ce" }}
                      >
                        {saturation_pressure_goals?.[item.label]?.current ||
                          "---"}
                      </div>
                      <div className="col-3 input-tooltip-valoration fw-bold">
                        {saturation_pressure_goals?.[item.label]?.goal || "---"}
                      </div>
                    </div>
                  );
                }
              })}
              <div className="col-12  d-flex ">
                <div
                  className="col-6 input-tooltip-valoration fw-bold"
                  style={{ textAlign: "left" }}
                >
                  Tensión
                </div>
                <div
                  className="col-3 input-tooltip-valoration fw-bold"
                  style={{ color: " #b6c1ce" }}
                >
                  {blood_pressure?.["pressure_s"]?.current || "---"} /{" "}
                  {blood_pressure?.["pressure_d"]?.current || "---"}
                </div>
                <div className="col-3 input-tooltip-valoration fw-bold">
                  {blood_pressure?.["pressure_s"]?.goal || "---"} /{" "}
                  {blood_pressure?.["pressure_d"]?.goal || "---"}
                </div>
              </div>
            </>
          )}
        </>
      ) : (
        <>
          {/* rest */}
          {cardiovascular_rest_goals && (
            <>
              <div
                className="d-flex align-items-center mx-auto my-2"
                style={{ width: "auto" }}
              >
                <span className="label-step-objectives ms-2">
                  Prueba en reposo
                </span>
              </div>
              <div className="col-12  d-flex ">
                <div
                  className="col-4 input-tooltip-valoration fw-bold"
                  style={{ textAlign: "left" }}
                ></div>
                <div className="col-2 input-tooltip-valoration fw-bold mx-1">
                  {formData?.initial_date || "---"}
                  <br></br>
                  Valor inicial
                </div>
                <div className="col-2 input-tooltip-valoration fw-bold mx-1">
                  <br></br>
                  Valor objetivo
                </div>
                <div className="col-2 input-tooltip-valoration fw-bold mx-1">
                  {formData?.current_date || "---"}
                  <br></br>
                  Valor alcanzado
                </div>
                <div className="col-2 input-tooltip-valoration fw-bold mx-1">
                  <br></br>
                  Resultado
                </div>
              </div>
              {reposoBaseControl.map((item) => {
                if (cardiovascular_rest_goals) {
                  return (
                    <div className="col-12  d-flex ">
                      <div
                        className="col-4 input-tooltip-valoration fw-bold mx-1"
                        style={{ textAlign: "left" }}
                      >
                        {item.name}
                      </div>
                      <div
                        className="col-2 input-tooltip-valoration fw-bold mx-1"
                        style={{ color: " #b6c1ce" }}
                      >
                        {cardiovascular_rest_goals?.[item.label]?.initial ||
                          "---"}
                      </div>
                      <div
                        className="col-2 input-tooltip-valoration fw-bold mx-1"
                        style={{ color: " #b6c1ce" }}
                      >
                        {cardiovascular_rest_goals?.[item.label]?.goal || "---"}
                      </div>
                      <div className="col-2 input-tooltip-valoration fw-bold mx-1">
                        {cardiovascular_rest_goals?.[item.label]?.current ||
                          "---"}
                      </div>
                      <div className="col-2 input-tooltip-valoration fw-bold mx-1">
                        {cardiovascular_rest_goals?.[item.label]?.achieved ? (
                          <i
                            className="bi bi-check-circle-fill"
                            style={{ color: "#00FF00" }}
                          ></i>
                        ) : (
                          (
                            <i
                              className="bi bi-x-circle-fill"
                              style={{ color: "#ff0000" }}
                            ></i>
                          ) || "---"
                        )}
                      </div>
                    </div>
                  );
                }
              })}
            </>
          )}
          {/* recuperation */}
          {cardiovascular_recovery_goals && (
            <>
              <div
                className="d-flex align-items-center mx-auto my-2"
                style={{ width: "auto" }}
              >
                <span className="label-step-objectives ms-2">
                  Prueba de recuperación
                </span>
              </div>
              <div className="col-12  d-flex ">
                <div
                  className="col-4 input-tooltip-valoration fw-bold"
                  style={{ textAlign: "left" }}
                ></div>
                <div className="col-2 input-tooltip-valoration fw-bold mx-1">
                  Valor inicial
                </div>
                <div className="col-2 input-tooltip-valoration fw-bold mx-1">
                  Valor objetivo
                </div>
                <div className="col-2 input-tooltip-valoration fw-bold mx-1">
                  Valor alcanzado
                </div>
                <div className="col-2 input-tooltip-valoration fw-bold mx-1">
                  Resultado
                </div>
              </div>
              {recuperationBaseControl.map((item) => {
                if (cardiovascular_recovery_goals) {
                  return (
                    <div className="col-12  d-flex ">
                      <div
                        className="col-4 input-tooltip-valoration fw-bold mx-1"
                        style={{ textAlign: "left" }}
                      >
                        {item.name}
                      </div>
                      <div
                        className="col-2 input-tooltip-valoration fw-bold mx-1"
                        style={{ color: " #b6c1ce" }}
                      >
                        {cardiovascular_recovery_goals?.[item.label]?.initial ||
                          "---"}
                      </div>
                      <div
                        className="col-2 input-tooltip-valoration fw-bold mx-1"
                        style={{ color: " #b6c1ce" }}
                      >
                        {cardiovascular_recovery_goals?.[item.label]?.goal ||
                          "---"}
                      </div>
                      <div className="col-2 input-tooltip-valoration fw-bold mx-1">
                        {cardiovascular_recovery_goals?.[item.label]?.current ||
                          "---"}
                      </div>
                      <div className="col-2 input-tooltip-valoration fw-bold mx-1">
                        {cardiovascular_recovery_goals?.[item.label]
                          ?.achieved ? (
                          <i
                            className="bi bi-check-circle-fill"
                            style={{ color: "#00FF00" }}
                          ></i>
                        ) : (
                          (
                            <i
                              className="bi bi-x-circle-fill"
                              style={{ color: "#ff0000" }}
                            ></i>
                          ) || "---"
                        )}
                      </div>
                    </div>
                  );
                }
              })}
            </>
          )}
          {/* saturation*/}
          {cardiovascular_recovery_goals && (
            <>
              <div
                className="d-flex align-items-center mx-auto my-2"
                style={{ width: "auto" }}
              >
                <span className="label-step-objectives ms-2">
                  Saturación oxigeno / Tensión arterial
                </span>
              </div>
              <div className="col-12  d-flex ">
                <div
                  className="col-4 input-tooltip-valoration fw-bold"
                  style={{ textAlign: "left" }}
                ></div>
                <div className="col-2 input-tooltip-valoration fw-bold mx-1">
                  Valor inicial
                </div>
                <div className="col-2 input-tooltip-valoration fw-bold mx-1">
                  Valor objetivo
                </div>
                <div className="col-2 input-tooltip-valoration fw-bold mx-1">
                  Valor alcanzado
                </div>
                <div className="col-2 input-tooltip-valoration fw-bold mx-1">
                  Resultado
                </div>
              </div>
              {saturationBaseControl.map((item) => {
                if (saturation_pressure_goals) {
                  return (
                    <div className="col-12  d-flex ">
                      <div
                        className="col-4 input-tooltip-valoration fw-bold mx-1"
                        style={{ textAlign: "left" }}
                      >
                        {item.name}
                      </div>
                      <div
                        className="col-2 input-tooltip-valoration fw-bold mx-1"
                        style={{ color: " #b6c1ce" }}
                      >
                        {saturation_pressure_goals?.[item.label]?.initial ||
                          "---"}
                      </div>
                      <div
                        className="col-2 input-tooltip-valoration fw-bold mx-1"
                        style={{ color: " #b6c1ce" }}
                      >
                        {saturation_pressure_goals?.[item.label]?.goal || "---"}
                      </div>
                      <div className="col-2 input-tooltip-valoration fw-bold mx-1">
                        <input
                          className={"input-corporal"}
                          type="number"
                          disabled={
                            saturation_pressure_goals?.[item.label]?.goal
                              ? false
                              : true
                          }
                          placeholder={
                            saturation_pressure_goals?.[item.label]?.current
                          }
                          onChange={(e) => {
                            setFormData((prev) => ({
                              ...prev,
                              achieved_goals: {
                                ...prev.achieved_goals,
                                cardiovascular: {
                                  ...prev.achieved_goals.cardiovascular,
                                  ["oxygen_saturation"]: {
                                    ...prev.achieved_goals.cardiovascular[
                                      "oxygen_saturation"
                                    ],
                                    values: {
                                      ...prev.achieved_goals.cardiovascular[
                                        "oxygen_saturation"
                                      ].values,
                                      current: Number(e.target.value),
                                    },
                                  },
                                },
                              },
                            }));
                          }}
                        />
                      </div>
                      <div className="col-2 input-tooltip-valoration fw-bold mx-1">
                        {saturation_pressure_goals?.[item.label]?.goal <=
                        saturation_pressure_goals?.[item.label]?.current ? (
                          <i
                            className="bi bi-check-circle-fill"
                            style={{ color: "#00FF00" }}
                          ></i>
                        ) : (
                          (
                            <i
                              className="bi bi-x-circle-fill"
                              style={{ color: "#ff0000" }}
                            ></i>
                          ) || "---"
                        )}
                      </div>
                    </div>
                  );
                }
              })}
              <div className="col-12  d-flex ">
                <div
                  className="col-4 input-tooltip-valoration fw-bold d-flex align-items-center mx-1"
                  style={{ textAlign: "left" }}
                >
                  Tensión
                </div>
                <div
                  className="col-2 input-tooltip-valoration fw-bold mx-1 d-flex align-items-center mx-1"
                  style={{ color: " #b6c1ce" }}
                >
                  {blood_pressure?.["pressure_s"]?.initial || "---"}/
                  {blood_pressure?.["pressure_d"]?.initial || "---"}
                </div>
                <div
                  className="col-2 input-tooltip-valoration fw-bold mx-1 d-flex align-items-center mx-1"
                  style={{ color: " #b6c1ce" }}
                >
                  {blood_pressure?.["pressure_s"]?.goal || "---"}/
                  {blood_pressure?.["pressure_d"]?.goal || "---"}
                </div>
                <div className="col-2 input-tooltip-valoration fw-bold mx-1 d-flex align-items-center mx-1">
                  {/* {blood_pressure?.["pressure_s"]?.current || "---"} /{" "}
                  {blood_pressure?.["pressure_d"]?.current || "---"} */}

                  <input
                    // placeholder="Sistólica"
                    type="number"
                    name="Sistólica"
                    onChange={(e) => {
                      setFormData((prev) => ({
                        ...prev,
                        achieved_goals: {
                          ...prev.achieved_goals,
                          cardiovascular: {
                            ...prev.achieved_goals.cardiovascular,
                            ["blood_pressure"]: {
                              ...prev.achieved_goals.cardiovascular[
                                "blood_pressure"
                              ],
                              ["pressure_s"]: {
                                ...prev.achieved_goals.cardiovascular[
                                  "blood_pressure"
                                ]["pressure_s"],
                                current: Number(e.target.value),
                              },
                            },
                          },
                        },
                      }));
                    }}
                    placeholder={
                      blood_pressure?.["pressure_s"]?.current || "Sist"
                    }
                    className=" input-corporal my-1"
                  />
                  <span className="input_info_athlete_input">/</span>
                  <input
                    placeholder={
                      blood_pressure?.["pressure_d"]?.current || "Dias"
                    }
                    type="number"
                    className=" input-corporal my-1"
                    onChange={(e) => {
                      setFormData((prev) => ({
                        ...prev,
                        achieved_goals: {
                          ...prev.achieved_goals,
                          cardiovascular: {
                            ...prev.achieved_goals.cardiovascular,
                            ["blood_pressure"]: {
                              ...prev.achieved_goals.cardiovascular[
                                "blood_pressure"
                              ],
                              ["pressure_d"]: {
                                ...prev.achieved_goals.cardiovascular[
                                  "blood_pressure"
                                ]["pressure_d"],
                                current: Number(e.target.value),
                              },
                            },
                          },
                        },
                      }));
                    }}
                  />
                </div>
                <div className="col-2 input-tooltip-valoration fw-bold mx-1 d-flex align-items-center mx-1">
                  {blood_pressure?.["pressure_s"]?.goal <=
                  blood_pressure?.["pressure_s"]?.current ? (
                    <i
                      className="bi bi-check-circle-fill"
                      style={{ color: "#00FF00" }}
                    ></i>
                  ) : (
                    <i
                      className="bi bi-x-circle-fill"
                      style={{ color: "#ff0000" }}
                    ></i>
                  )}{" "}
                  /{" "}
                  {blood_pressure?.["pressure_d"]?.goal <=
                  blood_pressure?.["pressure_d"]?.current ? (
                    <i
                      className="bi bi-check-circle-fill"
                      style={{ color: "#00FF00" }}
                    ></i>
                  ) : (
                    <i
                      className="bi bi-x-circle-fill"
                      style={{ color: "#ff0000" }}
                    ></i>
                  )}
                </div>
              </div>
            </>
          )}
        </>
      )}
    </div>
  );
};

export const CardioVascularComponent = ({ formData }) => {
  const cardiovascular_rest_goals = formData?.cardiovascular_rest_goals || null;
  const cardiovascular_recovery_goals =
    formData?.cardiovascular_recovery_goals || null;
  const saturation_pressure_goals = formData?.saturation_pressure_goals || null;

  return (
    <div className={classContainer}>
      {/* rest */}
      {cardiovascular_rest_goals && (
        <>
          <div
            className="d-flex align-items-center mx-auto my-2"
            style={{ width: "auto" }}
          >
            <span className="label-step-objectives ms-2">Prueba en reposo</span>
          </div>
          <div className="col-12  d-flex ">
            <div
              className="col-6 input-tooltip-valoration fw-bold"
              style={{ textAlign: "left" }}
            ></div>
            <div className="col-3 input-tooltip-valoration fw-bold">
              Valor actual
            </div>
            <div className="col-3 input-tooltip-valoration fw-bold">
              Valor objetivo
            </div>
          </div>
          {reposoBase.map((item) => {
            const nuevoKey = item.label.replace("goal", "actual");
            if (
              cardiovascular_rest_goals &&
              cardiovascular_rest_goals.hasOwnProperty(item.label)
            ) {
              return (
                <div className="col-12  d-flex ">
                  <div
                    className="col-6 input-tooltip-valoration fw-bold"
                    style={{ textAlign: "left" }}
                  >
                    {item.name}
                  </div>
                  <div
                    className="col-3 input-tooltip-valoration fw-bold"
                    style={{ color: " #b6c1ce" }}
                  >
                    {cardiovascular_rest_goals?.[nuevoKey] || "---"}
                  </div>
                  <div className="col-3 input-tooltip-valoration fw-bold">
                    {cardiovascular_rest_goals?.[item.label] || "---"}
                  </div>
                </div>
              );
            }
          })}
        </>
      )}
      {/* recuperation */}
      {cardiovascular_recovery_goals && (
        <>
          <div
            className="d-flex align-items-center mx-auto my-2"
            style={{ width: "auto" }}
          >
            <span className="label-step-objectives ms-2">
              Prueba de recuperación
            </span>
          </div>

          <div className="col-12  d-flex ">
            <div
              className="col-6 input-tooltip-valoration fw-bold"
              style={{ textAlign: "left" }}
            ></div>
            <div className="col-3 input-tooltip-valoration fw-bold">
              Valor actual
            </div>
            <div className="col-3 input-tooltip-valoration fw-bold">
              Valor objetivo
            </div>
          </div>
          {recuperationBase.map((item) => {
            const nuevoKey = item.label.replace("goal", "actual");
            if (
              cardiovascular_recovery_goals &&
              cardiovascular_recovery_goals.hasOwnProperty(item.label)
            ) {
              return (
                <div className="col-12  d-flex ">
                  <div
                    className="col-6 input-tooltip-valoration fw-bold"
                    style={{ textAlign: "left" }}
                  >
                    {item.name}
                  </div>
                  <div
                    className="col-3 input-tooltip-valoration fw-bold"
                    style={{ color: " #b6c1ce" }}
                  >
                    {cardiovascular_recovery_goals?.[nuevoKey] || "---"}
                  </div>
                  <div className="col-3 input-tooltip-valoration fw-bold">
                    {cardiovascular_recovery_goals?.[item.label] || "---"}
                  </div>
                </div>
              );
            }
          })}
        </>
      )}

      {/* saturation*/}
      {saturation_pressure_goals && (
        <>
          <div
            className="d-flex align-items-center mx-auto my-2"
            style={{ width: "auto" }}
          >
            <span className="label-step-objectives ms-2">
              Saturación oxigeno / Tensión arterial
            </span>
          </div>

          <div className="col-12  d-flex ">
            <div
              className="col-6 input-tooltip-valoration fw-bold"
              style={{ textAlign: "left" }}
            ></div>
            <div className="col-3 input-tooltip-valoration fw-bold">
              Valor actual
            </div>
            <div className="col-3 input-tooltip-valoration fw-bold">
              Valor objetivo
            </div>
          </div>
          {saturationBase.map((item) => {
            const nuevoKey = item.label.replace("goal", "actual");
            if (
              saturation_pressure_goals &&
              saturation_pressure_goals.hasOwnProperty(item.label)
            ) {
              return (
                <div className="col-12  d-flex ">
                  <div
                    className="col-6 input-tooltip-valoration fw-bold"
                    style={{ textAlign: "left" }}
                  >
                    {item.name}
                  </div>
                  <div
                    className="col-3 input-tooltip-valoration fw-bold"
                    style={{ color: " #b6c1ce" }}
                  >
                    {saturation_pressure_goals?.[nuevoKey] || "---"}
                  </div>
                  <div className="col-3 input-tooltip-valoration fw-bold">
                    {saturation_pressure_goals?.[item.label] || "---"}
                  </div>
                </div>
              );
            }
          })}
          <div className="col-12  d-flex ">
            <div
              className="col-6 input-tooltip-valoration fw-bold"
              style={{ textAlign: "left" }}
            >
              Tensión
            </div>
            <div
              className="col-3 input-tooltip-valoration fw-bold"
              style={{ color: " #b6c1ce" }}
            >
              {saturation_pressure_goals?.["blood_pressure_s_actual"] || "---"}/
              {saturation_pressure_goals?.["blood_pressure_d_actual"] || "---"}
            </div>
            <div className="col-3 input-tooltip-valoration fw-bold">
              {saturation_pressure_goals?.["blood_pressure_s_goal"] || "---"}/
              {saturation_pressure_goals?.["blood_pressure_d_goal"] || "---"}
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export const CorporalCompositionComponent = ({ formData }) => {
  const body_composition_goals = formData?.body_composition_goals || null;

  return (
    <div className={classContainer}>
      {/* rest */}
      {body_composition_goals && (
        <>
          <div className="col-12  d-flex ">
            <div
              className="col-6 input-tooltip-valoration fw-bold"
              style={{ textAlign: "left" }}
            ></div>
            <div className="col-3 input-tooltip-valoration fw-bold">
              Valor actual
            </div>
            <div className="col-3 input-tooltip-valoration fw-bold">
              Valor objetivo
            </div>
          </div>
          {optionLogsBase.map((item) => {
            const nuevoKey = item.label.replace("goal", "actual");
            if (
              body_composition_goals &&
              body_composition_goals.hasOwnProperty(item.label)
            ) {
              return (
                <div className="col-12  d-flex ">
                  <div
                    className="col-2 input-tooltip-valoration fw-bold d-flex"
                    style={{ textAlign: "left" }}
                  >
                    {item.image}
                  </div>
                  <div
                    className="col-4 input-tooltip-valoration fw-bold d-flex"
                    style={{ textAlign: "left" }}
                  >
                    {item.name}
                  </div>
                  <div
                    className="col-3 input-tooltip-valoration fw-bold"
                    style={{ color: " #b6c1ce" }}
                  >
                    {body_composition_goals?.[nuevoKey] || "---"}
                  </div>
                  <div className="col-3 input-tooltip-valoration fw-bold">
                    {body_composition_goals?.[item.label] || "---"}
                  </div>
                </div>
              );
            }
          })}
        </>
      )}
    </div>
  );
};

export const CorporalCompositionComponentControl = ({
  formData,
  dash = false,
}) => {
  const body_composition_goals =
    formData?.achieved_goals?.body_composition || null;

  return (
    <div className={classContainer}>
      {/* rest */}
      {body_composition_goals &&
        (dash ? (
          <>
            <div className="col-12  d-flex ">
              <div
                className="col-6 input-tooltip-valoration fw-bold"
                style={{ textAlign: "left" }}
              ></div>
              <div className="col-3 input-tooltip-valoration fw-bold">
                Valor actual
              </div>
              <div className="col-3 input-tooltip-valoration fw-bold">
                Valor objetivo
              </div>
            </div>
            {optionLogsBase.map((item) => {
              if (
                body_composition_goals &&
                body_composition_goals.hasOwnProperty(item.logKey)
              ) {
                return (
                  <div className="col-12  d-flex ">
                    <div
                      className="col-2 input-tooltip-valoration fw-bold d-flex"
                      style={{ textAlign: "left" }}
                    >
                      {item.image}
                    </div>
                    <div
                      className="col-4 input-tooltip-valoration fw-bold d-flex"
                      style={{ textAlign: "left" }}
                    >
                      {item.name}
                    </div>
                    <div
                      className="col-3 input-tooltip-valoration fw-bold"
                      style={{ color: " #b6c1ce" }}
                    >
                      {body_composition_goals?.[item.logKey]?.current_value ||
                        "---"}
                    </div>
                    <div className="col-3 input-tooltip-valoration fw-bold">
                      {body_composition_goals?.[item.logKey]?.goal_value ||
                        "---"}
                    </div>
                  </div>
                );
              }
            })}
          </>
        ) : (
          <>
            <div className="col-12  d-flex ">
              <div
                className="col-4 input-tooltip-valoration fw-bold"
                style={{ textAlign: "left" }}
              ></div>
              <div className="col-2 input-tooltip-valoration fw-bold mx-1">
                {formData?.initial_date || "---"}
                <br></br>
                Valor inicial
              </div>
              <div className="col-2 input-tooltip-valoration fw-bold mx-1">
                <br></br>
                Valor objetivo
              </div>
              <div className="col-2 input-tooltip-valoration fw-bold mx-1">
                {formData?.current_date || "---"}
                <br></br>
                Valor alcanzado
              </div>
              <div className="col-2 input-tooltip-valoration fw-bold mx-1">
                <br></br>
                Resultado
              </div>
            </div>
            {optionLogsBase.map((item) => {
              if (body_composition_goals) {
                return (
                  <div
                    className="col-12  d-flex pb-1"
                    style={{ borderBottom: "1px solid gray" }}
                  >
                    <div
                      className="col-2 input-tooltip-valoration fw-bold mx-1"
                      style={{ textAlign: "left" }}
                    >
                      {item.image}
                    </div>
                    <div
                      className="col-2 input-tooltip-valoration fw-bold mx-1"
                      style={{ textAlign: "left" }}
                    >
                      {item.name}
                    </div>
                    <div
                      className="col-2 input-tooltip-valoration fw-bold mx-1"
                      style={{ color: " #b6c1ce" }}
                    >
                      {body_composition_goals?.[item.logKey]?.initial_value ||
                        "---"}
                    </div>
                    <div
                      className="col-2 input-tooltip-valoration fw-bold mx-1"
                      style={{ color: " #b6c1ce" }}
                    >
                      {body_composition_goals?.[item.logKey]?.goal_value ||
                        "---"}
                    </div>
                    <div className="col-2 input-tooltip-valoration fw-bold mx-1">
                      {body_composition_goals?.[item.logKey]?.current_value ||
                        "---"}
                    </div>
                    <div className="col-2 input-tooltip-valoration fw-bold mx-1">
                      {body_composition_goals?.[item.logKey]?.achieved ? (
                        <i
                          className="bi bi-check-circle-fill"
                          style={{ color: "#00FF00" }}
                        ></i>
                      ) : (
                        <i
                          className="bi bi-x-circle-fill"
                          style={{ color: "#ff0000" }}
                        ></i>
                      )}
                    </div>
                  </div>
                );
              }
            })}
          </>
        ))}
    </div>
  );
};

export const PhysicTestComponent = ({ formData }) => {
  const physical_tests_goals = formData?.physical_tests_goals || null;
  console.log(physical_tests_goals, "physical_tests_goals");
  return (
    <div className={classContainer}>
      {/* rest */}
      {physical_tests_goals && (
        <>
          <div className="col-12  d-flex ">
            <div
              className="col-6 input-tooltip-valoration fw-bold"
              style={{ textAlign: "left" }}
            ></div>
            <div className="col-3 input-tooltip-valoration fw-bold">
              Valor actual
            </div>
            <div className="col-3 input-tooltip-valoration fw-bold">
              Valor objetivo
            </div>
          </div>
          {testPhysicalBase.map((item) => {
            const nuevoKey = item.label.replace("goal", "actual");
            if (
              physical_tests_goals &&
              physical_tests_goals.hasOwnProperty(item.label)
            ) {
              return (
                <div className="col-12  d-flex ">
                  <div
                    className="col-6 input-tooltip-valoration fw-bold d-flex"
                    style={{ textAlign: "left" }}
                  >
                    {item.name}
                  </div>
                  <div
                    className="col-3 input-tooltip-valoration fw-bold"
                    style={{ color: " #b6c1ce" }}
                  >
                    {physical_tests_goals?.[nuevoKey] || "---"}
                  </div>
                  <div className="col-3 input-tooltip-valoration fw-bold">
                    {physical_tests_goals?.[item.label] || "---"}
                  </div>
                </div>
              );
            }
          })}
        </>
      )}
    </div>
  );
};
export const PhysicTestComponentControl = ({
  formData,
  setFormData,
  dash = false,
}) => {
  const physical_tests_goals = formData?.physical_tests_goals || null;

  return (
    <div className={classContainer}>
      {/* rest */}
      {physical_tests_goals &&
        (dash ? (
          <>
            <div className="col-12  d-flex ">
              <div
                className="col-6 input-tooltip-valoration fw-bold"
                style={{ textAlign: "left" }}
              ></div>
              <div className="col-3 input-tooltip-valoration fw-bold">
                Valor actual
              </div>
              <div className="col-3 input-tooltip-valoration fw-bold">
                Valor objetivo
              </div>
            </div>
            {testPhysicalBase.map((item) => {
              const nuevoKey = item.label.replace("goal", "actual");
              if (
                physical_tests_goals &&
                physical_tests_goals.hasOwnProperty(item.label_actual)
              ) {
                return (
                  <div className="col-12  d-flex ">
                    <div
                      className="col-6 input-tooltip-valoration fw-bold d-flex"
                      style={{ textAlign: "left" }}
                    >
                      {item.name}
                    </div>
                    <div
                      className="col-3 input-tooltip-valoration fw-bold"
                      style={{ color: " #b6c1ce" }}
                    >
                      {physical_tests_goals?.[item.label_actual]
                        ?.initial_value || "---"}
                    </div>
                    <div className="col-3 input-tooltip-valoration fw-bold">
                      {physical_tests_goals?.[item.label_actual]?.goal_value ||
                        "---"}
                    </div>
                  </div>
                );
              }
            })}
          </>
        ) : (
          <>
            <div className="col-12  d-flex ">
              <div
                className="col-4 input-tooltip-valoration fw-bold"
                style={{ textAlign: "left" }}
              ></div>
              <div className="col-2 input-tooltip-valoration fw-bold mx-1">
                {formData?.initial_date || "---"}
                <br></br>
                Valor inicial
              </div>

              <div className="col-2 input-tooltip-valoration fw-bold mx-1">
                <br></br>
                Valor objetivo
              </div>
              <div className="col-2 input-tooltip-valoration fw-bold mx-1">
                {formData.current_date}
                <br></br>
                Valor alcanzado
              </div>
              <div className="col-2 input-tooltip-valoration fw-bold mx-1">
                <br></br>
                Resultado
              </div>
            </div>
            {testPhysicalBase.map((item) => {
              if (physical_tests_goals) {
                return (
                  <div
                    key={item.label}
                    className="col-12  d-flex pb-1"
                    style={{ borderBottom: "1px solid gray" }}
                  >
                    <div
                      className="col-4 input-tooltip-valoration fw-bold"
                      style={{ textAlign: "left" }}
                    >
                      {item.name}
                    </div>
                    <div className="col-2 input-tooltip-valoration fw-bold mx-1">
                      {physical_tests_goals?.[item.label_actual]
                        ?.initial_value || "---"}
                    </div>
                    <div className="col-2 input-tooltip-valoration fw-bold mx-1">
                      {physical_tests_goals?.[item.label_actual]?.goal_value ||
                        "---"}
                    </div>

                    <div className="col-2 input-tooltip-valoration fw-bold mx-1">
                      <input
                        className={"input-corporal"}
                        type="number"
                        disabled={
                          physical_tests_goals?.[item.label_actual]?.goal_value
                            ? false
                            : true
                        }
                        placeholder={
                          physical_tests_goals?.[item.label_actual]
                            ?.current_value
                        }
                        onChange={(e) => {
                          setFormData((prev) => ({
                            ...prev,
                            physical_tests_goals: {
                              ...prev.physical_tests_goals,
                              [item.label_actual]: {
                                ...prev.physical_tests_goals[item.label_actual],
                                current_value: Number(e.target.value),
                              },
                            },
                          }));
                        }}
                      />
                    </div>

                    <div className="col-2 input-tooltip-valoration fw-bold mx-1">
                      {physical_tests_goals?.[item.label_actual]?.goal_value <=
                      physical_tests_goals?.[item.label_actual]
                        ?.current_value ? (
                        <i
                          className="bi bi-check-circle-fill"
                          style={{ color: "#00FF00" }}
                        ></i>
                      ) : (
                        <i
                          className="bi bi-x-circle-fill"
                          style={{ color: "#ff0000" }}
                        ></i>
                      )}
                    </div>
                  </div>
                );
              }
            })}
          </>
        ))}
    </div>
  );
};

export const PRsComponent = ({ formData }) => {
  const pr_goals = formData?.pr_goals || null;

  return (
    <div className={classContainer}>
      {/* rest */}
      {Object.keys(pr_goals).length > 0 && (
        <>
          <div className="col-12  d-flex ">
            <div
              className="col-6 input-tooltip-valoration fw-bold"
              style={{ textAlign: "left" }}
            ></div>
            <div className="col-3 input-tooltip-valoration fw-bold">
              Valor actual
            </div>
            <div className="col-3 input-tooltip-valoration fw-bold">
              Valor objetivo
            </div>
          </div>
          {Object.values(pr_goals).map((item) => {
            return (
              <div className="col-12  d-flex ">
                <div
                  className="col-6 input-tooltip-valoration fw-bold d-flex"
                  style={{ textAlign: "left" }}
                >
                  {item.exercise_name}
                </div>
                <div
                  className="col-3 input-tooltip-valoration fw-bold"
                  style={{ color: " #b6c1ce" }}
                >
                  {item?.metric || "---"}
                </div>
                <div className="col-3 input-tooltip-valoration fw-bold">
                  {item?.goal || "---"}
                </div>
              </div>
            );
          })}
        </>
      )}
    </div>
  );
};
export const PRsComponentControl = ({ formData, dash = false }) => {
  const pr_goals = formData?.pr_goals || null;
  console.log(formData);
  return (
    <div className={classContainer}>
      {/* rest */}
      {Object.keys(pr_goals).length > 0 &&
        (dash ? (
          <>
            <div className="col-12  d-flex ">
              <div
                className="col-6 input-tooltip-valoration fw-bold"
                style={{ textAlign: "left" }}
              ></div>
              <div className="col-3 input-tooltip-valoration fw-bold">
                Valor actual
              </div>
              <div className="col-3 input-tooltip-valoration fw-bold">
                Valor objetivo
              </div>
            </div>
            {Object.values(pr_goals).map((item) => {
              return (
                <div className="col-12  d-flex ">
                  <div
                    className="col-6 input-tooltip-valoration fw-bold d-flex"
                    style={{ textAlign: "left" }}
                  >
                    {item.exercise_name}
                  </div>
                  <div
                    className="col-3 input-tooltip-valoration fw-bold"
                    style={{ color: " #b6c1ce" }}
                  >
                    {item?.metric || "---"}
                  </div>
                  <div className="col-3 input-tooltip-valoration fw-bold">
                    {item?.goal || "---"}
                  </div>
                </div>
              );
            })}
          </>
        ) : (
          <>
            <div className="col-12  d-flex ">
              <div
                className="col-4 input-tooltip-valoration fw-bold"
                style={{ textAlign: "left" }}
              ></div>
              <div className="col-2 input-tooltip-valoration fw-bold mx-1">
                {formData?.initial_date || "---"}
                <br></br>
                Valor inicial
              </div>
              <div className="col-2 input-tooltip-valoration fw-bold mx-1">
                <br></br>
                Valor objetivo
              </div>
              <div className="col-2 input-tooltip-valoration fw-bold mx-1">
                {formData?.current_date || "---"}
                <br></br>
                Valor alcanzado
              </div>
              <div className="col-2 input-tooltip-valoration fw-bold mx-1">
                <br></br>
                Resultado
              </div>
            </div>
            {Object.values(pr_goals).map((item) => {
              return (
                <div className="col-12  d-flex ">
                  <div
                    className="col-4 input-tooltip-valoration fw-bold"
                    style={{ textAlign: "left" }}
                  >
                    {item.exercise_name}
                  </div>
                  <div className="col-2 input-tooltip-valoration fw-bold mx-1">
                    {item?.metric || "---"}
                  </div>
                  <div className="col-2 input-tooltip-valoration fw-bold mx-1">
                    {item?.goal || "---"}
                  </div>
                  <div className="col-2 input-tooltip-valoration fw-bold mx-1">
                    {item?.current_metric || "---"}
                  </div>
                  <div className="col-2 input-tooltip-valoration fw-bold mx-1">
                    {item?.achieved ? (
                      <i
                        className="bi bi-check-circle-fill"
                        style={{ color: "#00FF00" }}
                      ></i>
                    ) : (
                      <i
                        className="bi bi-x-circle-fill"
                        style={{ color: "#ff0000" }}
                      ></i>
                    )}
                  </div>
                </div>
              );
            })}
          </>
        ))}
    </div>
  );
};

export const ChallengesComponent = ({ formData }) => {
  const challenges = formData?.challenges || null;

  return (
    <div className={classContainer}>
      {/* rest */}
      {Object.keys(challenges).length > 0 && (
        <>
          <div className="col-12  d-flex ">
            <div
              className="col-9 input-tooltip-valoration fw-bold"
              style={{ textAlign: "left" }}
            ></div>

            <div className="col-3 input-tooltip-valoration fw-bold">
              Valor objetivo
            </div>
          </div>
          {Object.values(challenges).map((item) => {
            return (
              <div className="col-12  d-flex ">
                <div
                  className="col-9 input-tooltip-valoration fw-bold d-flex"
                  style={{ textAlign: "left" }}
                >
                  {item.ch_name}
                </div>

                <div className="col-3 input-tooltip-valoration fw-bold">
                  {item?.goal || "---"}
                </div>
              </div>
            );
          })}
        </>
      )}
    </div>
  );
};
export const ChallengesComponentControl = ({
  formData,
  setFormData,
  dash = false,
}) => {
  const challenges = formData?.challenge || null;

  return (
    <div className={classContainer}>
      {/* rest */}
      {Object.keys(challenges).length > 0 &&
        (dash ? (
          <>
            <div className="col-12  d-flex ">
              <div
                className="col-9 input-tooltip-valoration fw-bold"
                style={{ textAlign: "left" }}
              ></div>

              <div className="col-3 input-tooltip-valoration fw-bold">
                Valor objetivo
              </div>
            </div>
            {Object.values(challenges).map((item) => {
              return (
                <div className="col-12  d-flex ">
                  <div
                    className="col-9 input-tooltip-valoration fw-bold d-flex"
                    style={{ textAlign: "left" }}
                  >
                    {item.ch_name}
                  </div>

                  <div className="col-3 input-tooltip-valoration fw-bold">
                    {item?.goal || "---"}
                  </div>
                </div>
              );
            })}
          </>
        ) : (
          <>
            <div className="col-12  d-flex ">
              <div
                className="col-5 input-tooltip-valoration fw-bold"
                style={{ textAlign: "left" }}
              ></div>

              <div className="col-4 input-tooltip-valoration fw-bold">
                ¿El usuario finalizó el reto?
              </div>
              <div className="col-3 input-tooltip-valoration fw-bold">
                Valor Objetivo
              </div>
            </div>
            {Object.values(challenges).map((item) => {
              return (
                <div
                  className="col-12  d-flex pb-1"
                  key={item.challenge_id}
                  style={{ borderBottom: "1px solid #b6c1ce" }}
                >
                  <div
                    className="col-5 input-tooltip-valoration fw-bold d-flex"
                    style={{ textAlign: "left" }}
                  >
                    {item.ch_name}
                  </div>

                  <div className="col-4 input-tooltip-valoration fw-bold  d-flex gap-2">
                    <div className="d-flex gap-1 align-items-center">
                      <input
                        name={item.challenge_id + "_achieved"}
                        type="checkbox"
                        checked={item.achieved}
                        onChange={(e) => {
                          setFormData((prev) => ({
                            ...prev,
                            challenge: {
                              ...prev.challenge,
                              [item.challenge_id]: {
                                ...prev.challenge[item.challenge_id],
                                achieved: e.target.checked,
                              },
                            },
                          }));
                        }}
                      />
                      <span className="input-tooltip-valoration">Si</span>
                    </div>
                    <div className="d-flex gap-1 align-items-center">
                      <input
                        type="checkbox"
                        name={item.challenge_id + "_achieved"}
                        checked={!item.achieved}
                        onChange={(e) => {
                          setFormData((prev) => ({
                            ...prev,
                            challenge: {
                              ...prev.challenge,
                              [item.challenge_id]: {
                                ...prev.challenge[item.challenge_id],
                                achieved: e.target.checked,
                              },
                            },
                          }));
                        }}
                      />
                      <span className="input-tooltip-valoration">No</span>
                    </div>
                  </div>
                  <div className="col-3 input-tooltip-valoration fw-bold">
                    {formData?.challenge?.[item.challenge_id]?.achieved ? (
                      <i
                        className="bi bi-check-circle-fill"
                        style={{ color: "#00FF00" }}
                      ></i>
                    ) : (
                      <i
                        className="bi bi-x-circle-fill"
                        style={{ color: "#ff0000" }}
                      ></i>
                    )}
                  </div>
                </div>
              );
            })}
          </>
        ))}
    </div>
  );
};
